import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { SideKickInterfaceTypeUiEnum } from 'src/app/_interfaces/sidekickTransaction';
import { DynamicFormSection } from 'src/app/_models/widget.models';
import { SidekickUiState } from 'src/app/_models/sidekick-widget.models';
import { SidekickWidgetService } from 'src/app/_services/sidekick/sidekick-widget.service';
import { PropertyUiPb } from 'src/app/com/staybloom/uiproto/property/propertyUiProto';

/**
 * Smart component owning all Sidekick setup UI.
 * Delegates all state management and API calls to SidekickWidgetService.
 * Uses async pipe in template to stay reactive without manual subscriptions.
 */
@Component({
  selector: 'app-sidekick-setup',
  templateUrl: './sidekick-setup.component.html',
  styleUrls: ['./sidekick-setup.component.scss'],
})
export class SidekickSetupComponent implements OnInit {
  @Input() description: string = '';
  @Input() formSections: DynamicFormSection[] | null = null;
  @Input() formValues: Record<string, any> | null = null;
  @Input() propertyData: PropertyUiPb;

  @Output() cancelled = new EventEmitter<void>();
  @Output() formSubmitted = new EventEmitter<any>();
  @Output() closeStateChanged = new EventEmitter<boolean>();

  readonly SideKickInterfaceTypeUiEnum = SideKickInterfaceTypeUiEnum;
  readonly state$: Observable<SidekickUiState>;

  constructor(private sidekickService: SidekickWidgetService) {
    this.state$ = this.sidekickService.state$;
  }

  ngOnInit(): void {
    this.sidekickService.initialize();
  }

  onFormSubmitted(data: any): void {
    this.formSubmitted.emit(data);
  }

  onCancelled(): void {
    this.cancelled.emit();
  }

  onCloseStateChanged(isClosed: boolean): void {
    this.closeStateChanged.emit(isClosed);
  }

  pushScreen(screenName?: SideKickInterfaceTypeUiEnum, reviewType?: string): void {
    this.sidekickService.pushSidekickScreen(screenName, reviewType, this.propertyData);
  }

  disconnect(): void {
    this.sidekickService.disconnectDevice();
  }

  retry(state: SidekickUiState): void {
    if (state.testConnection) {
      this.sidekickService.pushSidekickScreen(state.lastScreenName, undefined, this.propertyData);
    } else {
      this.sidekickService.retrySidekickConnect();
    }
  }

  toggleFeedback(): void {
    this.sidekickService.toggleFeedback();
  }
}
